import { getFirestore, collection, query, getDocs, onSnapshot } from "firebase/firestore"
import getCollectionPath from '@/services/firestore/getCollectionPath'
import catalogueCommands from '@/commands/catalogueCommands'

const db = getFirestore()
const collectionName = 'contractstatus/'

function docToInstance(document) {
  const data = document.data()
  return data ? new ContractStatus(document.id, data.name, data.description, data.color, data.offers, data.happiness, data.duration, data.durationUnit, data.latePayment, data.payOnAsking, data.outAtEnd, data.outNow, data.overwrite, data.appearanceRate, data.appearanceRule, data.available) : null
}

export default class ContractStatus {
  constructor(id, name, description, color, offers, happiness, duration, durationUnit, latePayment, payOnAsking, outAtEnd, outNow, overwrite, appearanceRate, appearanceRule, available = true) {
    this.id = id
    this.name = name
    this.description = description
    this.color = color
    this.offers = offers
    this.happiness = happiness
    this.duration = duration
    this.durationUnit = durationUnit
    this.latePayment = latePayment
    this.payOnAsking = payOnAsking
    this.outAtEnd = outAtEnd
    this.outNow = outNow
    this.overwrite = overwrite
    this.appearanceRate = appearanceRate
    this.appearanceRule = appearanceRule
    this.available = available
  }
  
  static initOne() {
    return new ContractStatus(null, 'Nouveau statut', 'Ceci est un nouveau statut', 'orange', [], [0, 100], [1, 1], 'month', false, false, false, false, false, 5, 'random', true)
  }

  static getDefaultStatus() {
    return [
      new ContractStatus('normal', 'Normal', 'Rien a signaler', 'brown', [], [0, 100], [1, 1], 'month', false, false, false, false, false, 0, 'random', true),
      new ContractStatus('signing', 'Signature', 'Ce contrat viens d\'etre signé', 'white', [], [0, 100], [1, 1], 'month', false, false, false, false, false, 0, 'random', true),
      new ContractStatus('canceling', 'Résiliation', 'Ce contrat seras annulé a la fin du mois', 'white', [], [0, 100], [1, 1], 'month', false, false, false, false, false, 0, 'random', true),
    ]
  } 

  async save() {
    const data = {
      name: this.name,
      description: this.description,
      color: this.color,
      offers: this.offers,
      happiness: this.happiness,
      duration: this.duration,
      durationUnit: this.durationUnit,
      latePayment: this.latePayment,
      payOnAsking: this.payOnAsking,
      outAtEnd: this.outAtEnd,
      outNow: this.outNow,
      overwrite: this.overwrite,
      appearanceRate: this.appearanceRate,
      appearanceRule: this.appearanceRule,
      available: this.available,
    }

    if (this.id) {
      await catalogueCommands.contractStatus.update(this.id, data)
    } else {
      const result = await catalogueCommands.contractStatus.create(data)
      this.id = result.id
    }
    return this
  }

  async delete() {
    await catalogueCommands.contractStatus.delete(this.id)
  }

  static async listenAll(callback) {
    const docsQuery = query(collection(db, await getCollectionPath(collectionName)))
    onSnapshot(docsQuery, snapshot => {
      const list = []
      snapshot.forEach(document => {
        list.push(docToInstance(document))
      })
      callback(list)
    })
  }

  static async getAll(){
    const documents = await getDocs(collection(db, await getCollectionPath(collectionName)))
    return documents.docs.map(docToInstance)
  }
}
